<template>
  <div class="page-content" @click.prevent="show = false">
    <el-popover class="tools" placement="right-start">
      <div class="tool-item" slot="reference" @click.stop="show = !show">
        <div class="tool-icon">
          <img v-if="!show" src="../../assets/img/tools1.svg" />
          <img v-else src="../../assets/img/tools2.svg" />
        </div>
        <div class="tool-icon" @click="goHome">
          <img src="../../assets/img/tools3.svg" />
        </div>
      </div>
      <!-- v-show="show"  -->
      <div class="tool-content">
        <!-- :href="'/#' + 'row' + (idx + 1)" -->
        <el-link
          v-for="(item, idx) in list"
          :key="idx"
          class="list-item"
          :class="'tool' + (idx + 1)"
          @click="scrollToTarget(idx)"
        >
          <img :src="require('../../assets/img/' + item.icon)" class="icon" />
          <span>{{ item.name }}</span>
        </el-link>
      </div>
    </el-popover>
    <div
      v-for="(item, idx) in list"
      :key="idx"
      class="row-video"
      :class="{
        ['row' + (idx + 1)]: true,
      }"
    >
      <a ref="row" href="#"></a>
      <div
        class="video-box"
        @click="videoState(idx)"
        :class="{
          stop: isPlaying != idx,
          ['row' + (idx + 1)]: true,
          play: isPlaying == idx,
        }"
      >
        <video :ref="'video' + idx" :src="item.video" class="video" controls>
          您的浏览器不支持 HTML5 视频。
        </video>
        <div class="video-mask"></div>
      </div>
      <el-row
        class="row-video-body"
        :class="{
          ['video' + idx]: true,
          fade: idx > 0 && scrollHeight && isShow('video' + idx, 'fade'),
        }"
      >
        <img :src="require('../../assets/img/' + item.img)" class="icon" />
        <h1 class="font-blod" v-html="item.text"></h1>
        <!-- {{ item.list.length }} -->
        <template v-if="item.list && item.list.length > 0">
          <el-col ref="fade" v-for="count in 2" :md="12" :xs="24" :key="count">
            <ul ref="list" class="list">
              <li
                v-for="(opt, i) in item.list.slice(
                  (count - 1) * item.page,
                  count == 2 ? item.list.length : count * item.page
                )"
                :key="idx + '_' + i"
              >
                <p v-html="opt"></p>
              </li>
            </ul>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "obras",
  props: {
    scrollHeight: Number,
  },
  data() {
    return {
      show: false,
      isPlaying: null,
      list: [
        {
          icon: "icon1.svg",
          name: "VIVIENDAS UNIFAMILIARES EXCLUSIVAS",
          img: "obras1.svg",
          video: "/video/video1.mp4",
          text: `VIVIENDAS UNIFAMILIARES<br/>EXCLUSIVAS`,
          page: 3,
          list: [
            `Como dirección técnica o jefatura de obra, hemos dirigido la 
construcción de más de 25 viviendas unifamiliares exclusivas 
en las zonas más prestigiosas de la Comunidad de Madrid.`,
            `La participación de los propietarios en el desarrollo del 
proyecto y elección de calidades aporta un valor añadido. `,
            `Estar cerca del cliente para orientarle, aconsejarle e interpretar sus necesidades a lo largo de la obra; complementar al arquitecto en cuestiones técnicas; ajustarnos a las especificaciones técnicas del proyecto; mostrar siempre una alta calidad
en obra,… son algunos de nuestros valores y de nuestro compromiso con la BUENA construcción.`,
            `Hemos realizado multitud de obras diferentes. Desde la sencillez de una construcción con estructura de paneles prefabricados de hormigón a una sofisticada estructura de acero. En la 
construcción de viviendas unifamiliares es básica la confianza 
en la empresa constructora. Son muchos meses de reuniones, 
asesoramiento y por supuesto eficiencia en la construcción.`,
            `Estamos capacitados para ayudarte a llevar a cabo tu proyecto. `,
            `El asesoramiento técnico al cliente, las mediciones de proyecto 
y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera que si fuera un gran proyecto.`,
          ],
        },
        {
          name: "PROMOCIONES Y OBRA EN ALTURA",
          icon: "icon2.svg",
          img: "obras2.svg",
          color: "#202b47",
          video: "/video/video2.mp4",
          text: `PROMOCIONES Y<br/>OBRA EN ALTURA`,
          page: 4,
          list: [
            `Desde la más sencilla promoción de un pareado hasta la que
            supera la centena de viviendas son proyectos que ejecutamos
            con la misma dedicación y profesionalidad.`,
            `Las edificaciones en altura tienen unos requisitos técnicos muy
            exigentes, sobre todo cuando tienes edificios adosados. Es el
caso de la edificación que estamos llevando a cabo en Madrid
donde tenemos por vecinos un colegio y un edificio de oficinas.
Todo controlado al milímetro. `,
            `
La confianza en la empresa constructora es básica para que el
 proyecto alcance el éxito.
`,
            `Y para alcanzar esa confianza lo primero es conocernos.`,
            `Te presentaremos nuestra empresa, nuestro personal técnico 
y nuestro trabajo.`,
            `Porque eficiencia en construcción también significa asesorar 
en las mejores soluciones en eficiencia energética o en los  
materiales que mejor se adapten al entorno y a las necesidades.`,
            `Porque eficiencia en construcción también es ajustarnos al 
plazo y al precio.`,
            `Estamos capacitados para ayudarte a llevar a cabo tu 
sueño/proyecto. `,
            `El asesoramiento técnico al cliente, las mediciones de proyecto 
y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera que si fuera un gran proyecto.`,
          ],
        },
        {
          name: "REFORMA INTEGRAL",
          icon: "icon3.svg",
          img: "obras3.svg",
          color: "#e1e3de",
          text: `REFORMA <br/>INTEGRAL`,
          page: 4,
          video: "/video/video3.mp4",
          list: [
            `Ya sea una reforma integral o la reforma de un salón, nos volcamos en cada obra de la misma manera. Asesoramos a nuestros clientes en cada decisión transmitiéndoles confianza y nos 
ocupamos de las tareas más engorrosas con la administración. Lodetalles y las terminaciones son una seña de identidad. `,
            `Realizamos un servicio de reconstrucción al más alto nivel 
brindando a su vivienda o negocio un nuevo aspecto y una 
nueva vida.`,
            `La calidad en el detalle que aplicamos en este tipo de obras es 
máxima.`,
            `Ya lo dice nuestro lema, <b class="fontblod">somos construadictos.</b>`,
            `Nos gusta nuestro trabajo y nos gusta hacerlo bien. Y no solo 
porque estamos preparados para hacerlo sino porque nuestra 
constante formación la aplicamos en cada obra para ser más <b class="fontblod">eficientes.</b>`,
            `Hemos realizado multitud de obras diferentes de este tipo. Una
 pequeña reforma en una vivienda o ayudarte a arrancar un negocio en un local, desde una sala de apuestas a un casino, un 
jardín de infancia o la reforma de una oficina, un pequeño
comercio o un restaurante, cines en centros comerciales o 
naves industriales.`,
            `Estamos capacitados para ayudarte a llevar a cabo tu sueño y 
tu proyecto. `,
            `El asesoramiento técnico al cliente, las mediciones de proyecto 
y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera que si fuera un gran proyecto.`,
          ],
        },
        {
          name: "OFICINAS, OCIO Y RETAIL",
          icon: "icon4.svg",
          img: "obras4.svg",
          color: "#97aae5",
          text: `OFICINAS,OCIO<br/>Y RETAIL`,
          page: 4,
          video: "/video/video4.mp4",
          list: [
            `Nuestra implicación en cada obra es absoluta. Hemos dedicado 
            muchos años a la construcción y reforma de los locales de importantes empresas de nuestro país.`,
            `La cara visible de una gran marca. Un trabajo a tres bandas: 
propietario arquitecto Maragon con un objetivo común.`,
            `El mismo concepto de construir pero con la creciente exigencia 
de los clientes, de eficiencia en todos los aspectos de la construcción.`,
            `La satisfacción de nuestros clientes con nuestro trabajo pasa 
por la calidad del mismo.`,
            `En <b class="fontblod">MARAGON</b> no solo damos importancia a la calidad del trabajo, también a la calidad humana y en particular a la calidad 
de la relación con nuestros clientes. Durante las reuniones 
previas a la obra os asesoramos en cada decisión transmitiendo confianza. Nuestra implicación en cada obra es absoluta. `,
            `Hemos realizado multitud de obras diferentes. Y en todas ellas 
buscamos la satisfacción del cliente.`,
            `Estamos capacitados para ayudarte a llevar a cabo tu proyecto. `,
            `El asesoramiento técnico al cliente, las mediciones de proyecto
 y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera que si fuera un gran proyecto.`,
          ],
        },
        {
          name: "CENTROS EDUCATIVOS Y DEPORTIVOS",
          icon: "icon5.svg",
          img: "obras5.svg",
          color: "#000000",
          video: "/video/video5.mp4",
          text: `CENTROS EDUCATIVOS <br/>Y DEPORTIVOS`,
          page: 5,
          list: [
            `Nuestra implicación en cada obra es absoluta ante la necesidad del cumplimiento de los plazos.`,
            `Porque sabemos que son obras que están condicionadas por 
las fechas y los plazos, hacemos una precisa planificación para 
lograr el éxito.`,
            `Cumplir los plazos, superar las dificultades, aportar soluciones a los problemas…`,
            `Buscamos la satisfacción del cliente a través de la calidad.`,
            `Valores éticos y humanos. Porque creemos en las personas.`,
            `Seguridad en la obra.`,
            `Formación continuada.`,
            `Educación y deporte son pilares básicos de nuestra sociedad.`,
            `Para MARAGON también son pilares básicos un trabajo de calidad, ajustarse a presupuesto y cumplir los plazos establecidos.`,
            `Estamos capacitados para ayudarte a llevar a cabo tu proyecto. `,
            `El asesoramiento técnico al cliente, las mediciones de proyecto 
y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera en todas nuestras obras.`,
          ],
        },
        {
          name: "OTRAS OBRAS",
          icon: "icon6.svg",
          img: "obras6.svg",
          color: "#50bac0",
          text: `OTRAS  <br/>OBRAS`,
          video: "/video/video6.mp4",
          page: 3,
          list: [
            `Restaurantes, Gimnasios, Salas de Apuestas y Casinos, Escuelas Infantiles, Naves Industriales, Cines, Comunidades. Estamos capacitados para ayudarte a llevar a cabo tu proyecto.`,
            `Hemos realizado obras muy variadas, desde una pequeña sala 
de apuestas a un casino, un jardín de infancia o la reforma de 
una oficina, un pequeño comercio o un restaurante.`,
            `El asesoramiento técnico al cliente, las mediciones de proyecto 
y trabajo codo a codo con el arquitecto lo aplicamos de la 
misma manera que si fuera un gran proyecto.`,
            `MARAGON <i> eficiencia en construcción</i> se presenta como una 
empresa sólida en el sector de la construcción, con un equipo
 humano propio con más de 15 años de experiencia. MARAGON 
 crece día a día, abarcando construcción, rehabilitación y reformas integrales, solucionando de manera eficaz cualquier demanda que al cliente le pueda surgir, respaldada por una cartera de obras de diferentes tipologías constructivas.`,
            `Nuestro compromiso es la máxima calidad del trabajo y la 
 mayor comodidad del cliente.`,
            `Somos minuciosos hasta el detalle. Autoexigencia, profesionalidad y constancia.`,
            `Porque disfrutamos de los que hacemos. Esto es lo que trasladamos a todos los que han confiado en nosotros y en aquellos que 
lo harán en un futuro próximo.`,
          ],
        },
      ],
    }
  },
  watch: {
    scrollHeight() {
      if (this.isShow(`video0`, "fade")) {
        document.querySelector(`.video0`).className =
          document.querySelector(`.video0`).className.replace("fade", "") +
          " fade"
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.scrollToTarget(this.$route.query.row)
      if (this.isShow(`video0`, "fade")) {
        document.querySelector(`.video0`).className =
          document.querySelector(`.video0`).className.replace("fade", "") +
          " fade"
      }
    }, 500)
  },
  methods: {
    videoState(idx) {
      this.stopVideo()
      if (this.isPlaying == idx) {
        this.$refs["video" + idx][0].pause()
        this.isPlaying = null
      } else {
        this.$refs["video" + idx][0].play()
        this.isPlaying = idx
      }
    },
    stopVideo() {
      let video = this.$refs
      for (let key in video){
        if (key.indexOf("video") > -1) video[key][0].pause()
      }
    },
    isShow(refName, a) {
      const l = document.querySelector(`.${refName}`)
      if (!l) return
      if (l.className.indexOf(a) > -1) return true
      let b = this.$utils.isElementInViewport(l)

      console.log(l, l.className, b, l.getBoundingClientRect())
      return b
    },
    scrollToTarget(idx) {
      const target = this.$refs.row[idx]
      // console.log(idx, target)
      if (target) {
        target.scrollIntoView({ behavior: "smooth" })
      }
    },
    goHome() {
      this.$router.push("/home")
    },
  },
}
</script>
<style lang="scss">
.fade {
  .list {
    opacity: 1;
    transition: opacity 2s;
  }
}
.list {
  opacity: 0;
  li {
    margin-bottom: 34px;
    padding-left: 60px + 30px;
    padding-right: 60px;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 30px;
      height: 30px;
      background-color: #c5ba60;
      position: absolute;
      left: 0;
      top: 6px;
      border-radius: 100%;
    }

    p {
      font-size: calc(var(--font-size) - 10px);
    }
    b {
      font-weight: bold;
    }
    i {
      font-style: italic;
      font-size: calc(var(--font-size) - 6px);
    }
  }
}

.tools {
  // position: fixed;
  // top: 400px;
  // left: 50px;
  position: fixed;
  bottom: 200px;
  left: 50px;
  z-index: 1000;
  .tool-item {
    width: 100px;
    .tool-icon {
      cursor: pointer;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
.el-popover {
  padding: 0px;
}
.tool-content {
  // width:1151px;
  // position: absolute;
  // left: calc(100% + 10px);
  // top: 0px;
  // z-index: 1000;
  height: 70%;
  display: flex;
  flex-direction: column;
  .list-item {
    padding: 20px;
    display: block;
    width: 100%;
    flex: 1;
    height: 100%;
    .el-link--inner {
      display: flex;
      align-items: center;
      span {
        white-space: nowrap;
        color: #fff;
      }
    }
    img {
      width: 70px;
      height: 70px;
      object-fit: cover;
      margin-right: 35px;
    }
    &.tool1 {
      background-color: #c5ba60;
    }
    &.tool2 {
      background-color: #202b47;
    }
    &.tool3 {
      background-color: #e1e3de;
      span {
        color: #000;
      }
    }
    &.tool4 {
      background-color: #97aae5;
    }
    &.tool5 {
      background-color: #000000;
    }
    &.tool6 {
      background-color: #50bac0;
    }
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  padding-top: 400px;
  padding-bottom: 570px;
  .row-video {
    position: relative;
    margin-bottom: 130px;
    .video-box {
      margin-bottom: 30px;
      display: flex;
      justify-content: center;
      position: relative;
      z-index: 10;
      .video {
        width: 100%;
        max-width: 1920px;
        // min-height: 1080px;
        // border: 1px solid #000;
        z-index: 9;
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 268px;
        left: 0px;
        bottom: 0px;
      }
    }
    .row-video-body {
      width: 100%;
      max-width: 1920px;
      margin: 0 auto;
      position: relative;
      .icon {
        position: absolute;
        width: 256px;
        height: 256px;
        margin-top: calc(-256px / 2);
        top: 0px;
        left: 0px;
        object-fit: cover;
        z-index: 11;
      }
      h1 {
        font-size: calc(var(--font-size) * 2);
        text-align: right;
        margin-bottom: 70px;
      }
    }
    &.row1 {
      .video-box::after,
      li::before {
        background-color: #c5ba60;
      }
      h1 {
        color: #c5ba60;
      }
    }
    &.row2 {
      .video-box::after,
      li::before {
        background-color: #202b47;
      }
      h1 {
        color: #202b47;
      }
    }
    &.row3 {
      .video-box::after,
      li::before {
        background-color: #e1e3de;
      }
      h1 {
        color: #e1e3de;
      }
    }
    &.row4 {
      .video-box::after,
      li::before {
        background-color: #97aae5;
      }
      h1 {
        color: #97aae5;
      }
    }
    &.row5 {
      .video-box::after,
      li::before {
        background-color: #000000;
      }
      h1 {
        color: #000000;
      }
    }
    &.row6 {
      .video-box::after,
      li::before {
        background-color: #50bac0;
      }
      h1 {
        color: #50bac0;
      }
    }
  }
}
</style>
